import React, { useContext } from 'react';
import styled from 'styled-components';
import { titleEditorStoreSelector, useTitleEditorStore } from '@warehouse/title/domain';
import CollapsableCard from '../../../../../../components/titles/CollapsableCard';
import DisplaySequence from './DisplaySequence';
import DisplayStringTable from './DisplayStringTable';
import Regions from './Regions';
import { CompanyDisplayCreditContext } from '../providers/companyDisplayCreditsProvider';

export interface CompanyDisplayCreditCardProps {
	index: number;
	defaultLocale: string | undefined;
}

const FlexWrapper = styled.div(
	({ theme }) => `
		display: flex;
		gap: ${theme.spacing(2)};
		
		.title-editable-field {
			padding: 0;
		}
	`,
);

export default function CompanyDisplayCreditCard({ index, defaultLocale }: CompanyDisplayCreditCardProps) {
	const companyDisplayCreditContext = useContext(CompanyDisplayCreditContext);
	const editMode = useTitleEditorStore(titleEditorStoreSelector.editMode);

	return (
		<CollapsableCard
			label={`Company #${index + 1}`}
			showDeleteIcon={editMode}
			onClickDeleteIcon={() => {
				companyDisplayCreditContext.removeCompanyDisplayCredit(index);
				companyDisplayCreditContext.commit();
			}}
		>
			<FlexWrapper>
				<div style={{ width: '70%' }}>
					<Regions companyDisplayCreditDisplayIndex={index} />
				</div>
				<div style={{ width: '30%' }}>
					<DisplaySequence companyDisplayCreditDisplayIndex={index} />
				</div>
			</FlexWrapper>
			<DisplayStringTable companyDisplayCreditDisplayIndex={index} defaultLocale={defaultLocale} />
		</CollapsableCard>
	);
}
